import { Chip } from "@material-ui/core";
import {
  Activity,
  ActivityFeedItemDefinition,
} from "@ofqual/portal-activity-feed";
import React from "react";
import { ActivityType } from "../../../domain/ActivityType";
import { News } from "../../../domain/News";
import { fieldLabels } from "../../sections/fieldLabels";
import { ChangeActivityBody } from "./types";

export const buildDefinitions = (
  newsItem: News,
  onClick: (entity: Activity | null) => void
) => {
  if (!newsItem) {
    return [];
  }

  const newsUpdated: ActivityFeedItemDefinition<ChangeActivityBody> = {
    activityType: ActivityType.NewsUpdated,
    Body: ({ body }) => (
      <>
        <b>Updated:</b>{" "}
        {body.changes.map((item) => (
          <Chip
            size="small"
            style={{ margin: 2, display: "flex-grid" }}
            label={fieldLabels[item.field]}
            className="ChangeChip"
            key={item.field}
          />
        ))}
      </>
    ),
    options: [
      {
        label: "Show Changes",
        onClick,
      },
    ],
  };

  const newsArchived: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.NewsArchived,
  };

  const newsUnArchived: ActivityFeedItemDefinition<{}> = {
    activityType: ActivityType.NewsUnarchived,
  };
  return [newsUpdated, newsArchived, newsUnArchived];
};
